import { render } from "./CreateDiagramTile.vue?vue&type=template&id=271ee7f8&scoped=true"
import script from "./CreateDiagramTile.vue?vue&type=script&lang=ts"
export * from "./CreateDiagramTile.vue?vue&type=script&lang=ts"

import "./CreateDiagramTile.vue?vue&type=style&index=0&id=271ee7f8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-271ee7f8"

export default script